import { Reducer } from "redux";

import { AdminAccessListResponse } from "../models/api/Admin";
import { AccessAdminActionTypes } from "../models/dispatchTypes/User";
import { AccessAdminListActionDispatchTypes } from "../constants/User";

const initialState: AdminAccessListResponse = {
  loading: false,
  response: null,
  error: null,
};

const PostAdminAccessListReducer: Reducer<
AdminAccessListResponse,
AccessAdminActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AccessAdminListActionDispatchTypes.ACCESS_ADMIN_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case AccessAdminListActionDispatchTypes.ACCESS_ADMIN_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case AccessAdminListActionDispatchTypes.ACCESS_ADMIN_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case AccessAdminListActionDispatchTypes.ACCESS_ADMIN_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostAdminAccessListReducer;
